export default __webpack_public_path__ + "static/media/intro-connection-dark.aebc29db.jpg";